import React from 'react';


export const LandingFeatures = ({ t }) => (
      <section id="features" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="mx-auto max-w-7xl">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-orange-100 text-orange-700 rounded-full text-sm font-semibold mb-4">
              ✨ {t('landing.whyChoose')}
            </div>
            <h2 className="font-heading text-4xl font-bold text-gray-900 mb-4">
              {t('landing.featuresTitle')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('landing.featuresSubtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Feature Cards */}
            {[
              {
                icon: '💰',
                titleKey: 'landing.features.transparentPricing.title',
                descKey: 'landing.features.transparentPricing.desc',
                color: 'from-orange-500 to-red-600'
              },
              {
                icon: '🏥',
                titleKey: 'landing.features.worldClassFacilities.title',
                descKey: 'landing.features.worldClassFacilities.desc',
                color: 'from-blue-500 to-cyan-600'
              },
              {
                icon: '👨‍⚕️',
                titleKey: 'landing.features.verifiedSpecialists.title',
                descKey: 'landing.features.verifiedSpecialists.desc',
                color: 'from-green-500 to-emerald-600'
              },
              {
                icon: '🔒',
                titleKey: 'landing.features.securePrivate.title',
                descKey: 'landing.features.securePrivate.desc',
                color: 'from-purple-500 to-pink-600'
              },
              {
                icon: '🌍',
                titleKey: 'landing.features.endToEndSupport.title',
                descKey: 'landing.features.endToEndSupport.desc',
                color: 'from-yellow-500 to-orange-600'
              },
              {
                icon: '⚡',
                titleKey: 'landing.features.quickResponse.title',
                descKey: 'landing.features.quickResponse.desc',
                color: 'from-red-500 to-pink-600'
              }
            ].map((feature, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl p-8 border-2 border-gray-100 hover:border-orange-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
                data-testid={`feature-card-${index}`}
              >
                <div className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-2xl flex items-center justify-center text-3xl mb-6 group-hover:scale-110 transition-transform`}>
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {t(feature.titleKey)}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {t(feature.descKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
);
